// extracted by mini-css-extract-plugin
export default {"photo":"employee-image-modal_photo__SMgH7","placeholder":"employee-image-modal_placeholder__NV0jS"};